import { useCallback, useEffect, useMemo, useState } from 'react';
import type { AdvanceRequest } from '@/types';
import { SearchFilterBar } from '@/components/base/SearchFilterBar';

interface LoanFiltersProps {
  loans: AdvanceRequest[];
  onFilterChange: (filtered: AdvanceRequest[]) => void;
}

const FILTERS = [
  { id: '', label: 'Tất cả', statuses: [] },
  { id: 'pending', label: 'Chờ duyệt', statuses: ['Chờ kiểm tra', 'Cần bổ sung'] },
  { id: 'approved', label: 'Đã duyệt', statuses: ['Đã duyệt', 'approved_locked', 'Chờ giải ngân'] },
  { id: 'done', label: 'Đã giải ngân', statuses: ['Đã giải ngân', 'disbursed'] },
  { id: 'closed', label: 'Đã đóng', statuses: ['Từ chối', 'Đã tất toán'] },
];

export default function LoanFilters({ loans, onFilterChange }: LoanFiltersProps) {
  const [search, setSearch] = useState('');
  const [active, setActive] = useState('');
  const counts = useMemo(() => Object.fromEntries(FILTERS.map((filter) => [filter.id, filter.id ? loans.filter((loan) => filter.statuses.includes(loan.status)).length : loans.length])), [loans]);

  const runFilter = useCallback(() => {
    const query = search.trim().toLowerCase();
    const config = FILTERS.find((filter) => filter.id === active);
    onFilterChange(loans.filter((loan) => {
      if (query && !`${loan.maKhoanVay ?? ''} ${loan.id} ${loan.mucDich}`.toLowerCase().includes(query)) return false;
      if (config?.id && !config.statuses.includes(loan.status)) return false;
      return true;
    }));
  }, [active, loans, onFilterChange, search]);

  useEffect(() => { runFilter(); }, [runFilter]);

  return (
    <SearchFilterBar
      value={search}
      onChange={setSearch}
      placeholder="Tìm mục đích hoặc mã yêu cầu"
      selected={active}
      onSelect={setActive}
      options={FILTERS.map((filter) => ({ value: filter.id, label: filter.label, count: counts[filter.id] || 0 }))}
    />
  );
}
